import { render, staticRenderFns } from "./Sinoptico.vue?vue&type=template&id=c6dee7be&scoped=true&"
import script from "./Sinoptico.vue?vue&type=script&lang=js&"
export * from "./Sinoptico.vue?vue&type=script&lang=js&"
import style0 from "./Sinoptico.vue?vue&type=style&index=0&id=c6dee7be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dee7be",
  null
  
)

export default component.exports